import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialDownloadState = {
  downloadStatus: STATUS.IDLE,
  //customerOrganizationSubscription: [],
  //customerOrganizationSubscriptionStatus: STATUS.IDLE,
  //customerOrganizationsData: [],
};

export default (state = initialDownloadState, action) => {
  switch (action?.type) {
    case types.FILE_DOWNLOAD:
      return {
        ...state,
        downloadFileStatus: STATUS.LOADING,
      };
    case resolve(types.FILE_DOWNLOAD): {
      return {
        ...state,
        downloadFileStatus: STATUS.LOADED,
      };
    }
    case reject(types.FILE_DOWNLOAD):
      return {
        ...state,
        error: true,
        downloadFileStatus: STATUS.ERROR,
      };
    case types.FILE_CONTENT_COPY:
      return {
        ...state,
        copyFileContentStatus: STATUS.LOADING,
      };
    case resolve(types.FILE_CONTENT_COPY): {
      let response = action?.payload;
      if (response?.status_code == 200) {
        navigator.clipboard.writeText(JSON.stringify(response?.response));
      }
      return {
        ...state,
        copyFileContentStatus: STATUS.LOADED,
      };
    }
    case reject(types.FILE_CONTENT_COPY):
      return {
        ...state,
        error: true,
        copyFileContentStatus: STATUS.ERROR,
      };
    default:
      return state;
  }
};
